import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'daysAndNights'})

export class DaysAndNightsPipe implements PipeTransform {

  transform(value: string[]): string {

    let date1 = new Date(value[0]);
    let date2 = new Date(value[1]);

    let diff_time = date2.getTime() - date1.getTime();
    let diff_days = Math.round(diff_time / (1000 * 3600 * 24));
    
    return diff_days+1 + ' giorni / ' + diff_days + ' notti'
  }
}

// if(this.rangeDates.value){

//     let date1 = correctDate(this.rangeDates.value[0]!);
//     let date2 = correctDate(this.rangeDates.value[1]!);

//     let diff_time = date2.getTime() - date1.getTime();

//     let diff_days = Math.round(diff_time / (1000 * 3600 * 24));

//     console.log(diff_days+1 + ' giorni / ' + diff_days + ' notti');
//   }